import React from 'react';
import SearchBanner from './SearchBanner';
import InfoContent from './InfoContent';
import Specialties from './Specialties';
import ReviewsContent from './ReviewsContent';
import Doctors from './Doctors';
import FaqContent from './FaqContent';
import footerBanner from './assests/footerBanner.png';
import { IoSearchSharp } from 'react-icons/io5';

const HomePage = () => {
  return (
    <div>
      <SearchBanner />
      <Specialties />
      <Doctors />
      <InfoContent />
      {/* <ReviewsContent /> */}
      {/* <FaqContent /> */}
      <div className="relative flex ">
        <div className="w-full bg-black bg-opacity-25 relative">
          <img
            src={footerBanner}
            alt="home"
            className="w-full md:h-[500px] h-full relative -z-10 object-cover"
          />
        </div>
        <div className="absolute p-4 w-full h-full flex justify-center items-center">
          <div className="flex gap-4 items-center text-center">
            {/* <IoSearchSharp size={52} color="white" /> */}
            <h2 className="text-white text-4xl">Dermatologistas a um clique!</h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
